import { apiCall } from "../../../api-calls/api-call"
import { AccountInstalledPackage } from "../store/account-tracking.store"

export const getAccountInstalledPackages = async(
  accountId: string,
): Promise<AccountInstalledPackage[]> => {
  return apiCall({
    method: "GET",
    path: "buff-play/tracking/installed-packages",
    query: { accountId },
  })
}

export const updateAccountPackage = async(
  accountId: string,
  platformId: string,
  active: boolean,
): Promise<AccountInstalledPackage> => {
  return apiCall({
    method: "PATCH",
    path: "buff-play/tracking/installed-packages",
    body: {
      accountId,
      platformId,
      active,
    },
  })
}
